import request from "../request";

import { GetProfileResponse } from "./types";

export const getProfile = () => {
  return request.get<GetProfileResponse>("/me");
};
